import akshay from '../assest/akshay.png';
const AboutUs = () => {
  const teamMembers = [
    {
      name: "Akshay Jain",
      title: "Founder",
      image: akshay,
      bio: "I'm a data-driven, AI-first problem solver on a mission to do work that meaningfully improves lives. With over a decade in Tech, I've held impactful roles at Helix, Robinhood, Uber, and Meta, driving innovation and efficiency. I hold a Master's in Computer Science from NYU and enjoy reading and hiking in my free time."
    }
  ];

  return (
    <div className="max-w-6xl mx-auto px-4 py-16">
      
      <div className="flex justify-center">
        {teamMembers.map((member, index) => (
          <div key={index} className="bg-gray-100 rounded-lg pt-8 pb-8 pl-4 pr-4 text-center max-w-md">
            <div className="flex justify-center mb-4">
              {index === 1 ? (
                <div className="w-32 h-32 rounded-full bg-gray-900 flex items-center justify-center overflow-hidden">
                  <img 
                    src={member.image} 
                    alt={member.name} 
                    className="w-full h-full object-cover"
                  />
                </div>
              ) : (
                <div className="w-32 h-32 rounded-full bg-gray-200 flex items-center justify-center overflow-hidden">
                  <img 
                    src={member.image} 
                    alt={member.name} 
                    className="w-full h-full object-cover"
                  />
                </div>
              )}
            </div>
            
            <h2 className="text-2xl font-bold mb-1">{member.name}</h2>
            <p className="text-gray-600 mb-6">{member.title}</p>
            
            <p className="font-inter font-light text-[16px] leading-[28px] tracking-[0px] text-center flex items-center justify-center">
              {member.bio}
            </p>
          </div>
        ))}
      </div>
    </div>
  );
};

export default AboutUs;